import React from 'react';
import { components } from 'react-select';

const Input = (props) => <components.Input {...props} />;

export default Input;
